module.exports = __webpack_public_path__ + "static/media/enfant-parti.10bf0f5e.svg";